import underwaterMp3 from "../assets/audio/underwater.mp3";
import bubbleMp3 from "../assets/audio/bubble.mp3";

export class Soundboard {
  underwater: HTMLAudioElement;
  bubbleSound: HTMLAudioElement;

  constructor() {
    this.underwater = new Audio(underwaterMp3);

    this.bubbleSound = new Audio(bubbleMp3);
    this.bubbleSound.volume = 0.5;
  }
}
